import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTabImg from 'eco-design/sections/eco-tab-img';
import style from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.ListB');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = ['jp'].includes(locale);
    const itemsA = [
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597092/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324181/1.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597092/1.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324181/1.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224596124/1-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352323991/1-h5.jpg',
            tabLabel: t('item1_title'),
            tabValue: '11',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597277/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324550/2.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597277/2.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324550/2.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224596913/2-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324363/2-h5.jpg',
            tabLabel: t('item2_title'),
            tabValue: '22',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597706/3.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744356580690/3.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324946/3.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597706/3.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744356580690/3.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324946/3.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597897/3-h5.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1745225021953/3-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744352324752/3-h5.jpg',
            tabLabel: t('item3_title'),
            tabValue: '33',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224598515/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880588713/4.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224598515/4.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880588713/4.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224597456/4-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880588535/4-h5.jpg',
            tabLabel: t('item4_title'),
            tabValue: '44',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745721266596/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880588948/5.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745721266596/5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880588948/5.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745721252178/5-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744880589118/5-h5.jpg',
            tabLabel: t('item5_title'),
            tabValue: '55',
        },
        {
            pc: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224596481/6.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744701531344/6.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744701531742/6-ss.jpg',
            pad: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224596481/6.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744701531344/6.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744701531742/6-ss.jpg',
            h5: IS_JP_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1745224596702/6-h5.jpg'
                : locale === 'us'
                ? 'https://websiteoss.ecoflow.com/upload/image/1744701969212/6-h5.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1744701920610/6-h5-ss.jpg',
            tabLabel: t('item6_title'),
            tabValue: '55',
        },
        locale !== 'jp' && {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744701531575/7.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744701531575/7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744701969372/7-h5.jpg',
            tabLabel: t('item7_title'),
            tabValue: '55',
        },
    ].filter(Boolean);
    return (
        <div id="ListB" className="GtmModuleData-section" data-section-id="ListB" data-section-classname=".eco-section-title">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <EcoTabImg className={style.tabImg} items={itemsA} />
        </div>
    );
}
